import gql from 'graphql-tag';

const DEVICE_TROUBLESHOOTING_FILTERS = gql`
  query Query($filters: [String!], $currentView: String!, $searchParam: String!, $searchText: String!) {
    deviceTroubleShootingFilters(
      filters: $filters
      currentView: $currentView
      searchParam: $searchParam
      searchText: $searchText
    ) {
      latitude
      longitude
      elevation
      deviceType
      deviceSerialNo
    }
  }
`;

export default DEVICE_TROUBLESHOOTING_FILTERS;
